import styled from "styled-components";
import { FlexColumnDiv } from "./common.styles";
import { HXCheckbox } from "./base.styles";
export const CheckboxGroup = styled(FlexColumnDiv) `
    gap: 4px;
`;
export const Checkbox = styled(HXCheckbox) `
    margin-right: 0;
`;
